module.exports = __webpack_public_path__ + "media/img/event/Sponsor-Middle-Tennessee-State-University-01619d11bcf4354e996303bf992d2a59.jpg";